import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { DatePipe } from '@angular/common';
import { timestamp } from 'rxjs';

@Component({
  selector: 'app-dashboard-disable-model',
  templateUrl: './dashboard-disable-model.component.html',
  styleUrl: './dashboard-disable-model.component.scss'
})

export class DashboardDisableModelComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData,
    private dialogRef: MatDialogRef<DashboardDisableModelComponent>,
    private fnutilservice: FnUtilService,
    private toaster: FnToasterService,
    private posHttpSvcs: PosHttpService,
    public datepipe: DatePipe
  ) { }

  timeEvent: any;
  changeDate(event: any) {
    const currentTime = new Date().getTime();
    const diffInHrs = (event - currentTime) / (1000 * 60 * 60);
    if (diffInHrs > 24) {
      this.toaster.error("select time less then or equal to 24 hrs.");
      close();
    }else{
    this.timeEvent = this.datepipe.transform(event, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
     }
    }
   
  disable() {
  if (!this.timeEvent) {
    this.toaster.error("Please select disable time within 24 hours.");
    return;
  }
  const pktData = {
    timeEvent: this.timeEvent,
    pk: this.dialogData.pk
  };
  this.posHttpSvcs.authPost('v1/ui/disableAlerts', 'disableAlerts', pktData).subscribe(resp => {
    if (resp.isError) {
      this.toaster.error(resp.data);
      this.close();
    } else {
      this.toaster.success(resp.data);
    }
    this.dialogRef.close(resp.isError);
  });
}

  close() {
    this.dialogRef.close();
  }

}

interface HwDialogData {
  pk: any;
}
